function setGender (gender) {
  const lowGender = gender.toLowerCase();
  if (lowGender === 'men' || lowGender === 'women') { document.cookie = `assumedGender=${lowGender};path=/`; };
}

function getGenderIfMatch (string) {
  const regexWomen = /\W(women|damen|dam|femmes|dame|female)(\W|$)/i;
  const regexMen = /\W(men|herren|herr|homme|herre|male)(\W|$)/i;
  if (regexWomen.test(string)) return 'women';
  if (regexMen.test(string)) return 'men';
  return '';
}
function setGenderIfMatch (string) {
  const gender = getGenderIfMatch(string);
  if (gender) {
    setGender(gender);
  }
}

function setGenderFromUrl () {
  const regex = /\W(women|damen|dam|femmes|dame|female)(\W|$)/i;
  const urlSearchParams = new URLSearchParams(window.location.search);
  if (regex.test(window.location.pathname) || (urlSearchParams.has('women') && urlSearchParams.get('women') === 'true')) {
    document.cookie = 'assumedGender=women;path=/';
    return 'women';
  }
  return '';
}

function getGender () {
  if (!document.referrer.includes('norrona') || !document.referrer.includes('localhost')) {
    const urlGender = setGenderFromUrl();
    if (urlGender === 'women') return 'women';
  }

  const genderCookie = document.cookie.split('; ').find(row => row.startsWith('assumedGender='));
  if (genderCookie) {
    const genderArray = genderCookie.split('=');
    if (genderArray.length === 2) return genderArray[1];
  }
  return 'men';
}

export default {
  setGender, getGender, setGenderIfMatch, getGenderIfMatch
};
